<template>
  <datetime v-model="fieldValue" auto="true">
    <template slot="button-cancel">
    Cancel
  </template>
  </datetime>
</template>

<script>
import dayjs from 'dayjs'
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
const customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat)

export default { 
  name: 'DatePickerField',
  components: {
    Datetime
  },
  props: {
    options: {
      type: Object,
      required: true
    },
    value: {
      type: String
    }
  },
  methods: {
    validate () {
      return dayjs(this.value, 'YYYY-MM-DD', true).isValid()
    }
  },
  computed: {
    isValid () {
      return dayjs(this.value, 'YYYY-MM-DD', true).isValid()
    },
    fieldValue: {
      get() {
        return (this.value ? this.value : false)
      },
      set(val) {
        let dt = dayjs(val)
        this.$commit.setFieldValue({
          key: 'field-' + this.options.id, 
          value: dt.format('YYYY-MM-DD')
        })
      }
    }
  }
}
  
</script>
